import { RED_500, tokens } from '@airtel/air-design-system';
import { Dimensions, StyleSheet } from 'react-native';
export var getIconButtonGroupWidgetStyles = props => {
  var _Dimensions$get = Dimensions.get('window'),
    screenWidth = _Dimensions$get.width;
  var allItemsInSingleRow = props.allItemsInSingleRow,
    _props$itemsToBeShown = props.itemsToBeShownInRow,
    itemsToBeShownInRow = _props$itemsToBeShown === void 0 ? 4 : _props$itemsToBeShown,
    emphasizerProps = props.emphasizerProps,
    data = props.data,
    useNewStyle = props.useNewStyle;
  var itemsInSingleRow = () => {
    if (allItemsInSingleRow) {
      return 'space-around';
    } else {
      return 'flex-start';
    }
  };
  var _tokens$spacing = tokens.spacing,
    SPACING_0 = _tokens$spacing.SPACING_0,
    SPACING_2 = _tokens$spacing.SPACING_2,
    SPACING_4 = _tokens$spacing.SPACING_4,
    SPACING_10 = _tokens$spacing.SPACING_10,
    SPACING_16 = _tokens$spacing.SPACING_16,
    SPACING_12 = _tokens$spacing.SPACING_12,
    SPACING_28 = _tokens$spacing.SPACING_28;
  var _tokens$borderRadius = tokens.borderRadius,
    BORDER_RADIUS_4 = _tokens$borderRadius.BORDER_RADIUS_4,
    BORDER_RADIUS_8 = _tokens$borderRadius.BORDER_RADIUS_8;
  var emphasizerColor = (emphasizerProps === null || emphasizerProps === void 0 ? void 0 : emphasizerProps.stripColor) || RED_500;
  var emphasizerOnLastRow = (emphasizerProps === null || emphasizerProps === void 0 ? void 0 : emphasizerProps.index) + itemsToBeShownInRow >= (data === null || data === void 0 ? void 0 : data.length);
  var ICON_WIDTH = 72;
  var shouldUseNewStyle = useNewStyle && screenWidth > 375;
  return StyleSheet.create({
    qabWrapper: {
      position: 'relative',
      width: shouldUseNewStyle ? ICON_WIDTH : allItemsInSingleRow ? 100 : 100 / itemsToBeShownInRow + "%",
      alignItems: 'center',
      paddingHorizontal: shouldUseNewStyle ? SPACING_0 : SPACING_2
    },
    qabDataContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: shouldUseNewStyle ? 'space-between' : itemsInSingleRow(),
      position: 'relative'
    },
    qabDataContainerSpacer: {
      marginBottom: shouldUseNewStyle ? SPACING_16 : SPACING_28
    },
    emphasizerPointer: {
      width: 20,
      height: 20,
      borderRadius: BORDER_RADIUS_4,
      backgroundColor: emphasizerColor,
      position: 'absolute',
      bottom: -26,
      alignSelf: 'center',
      transform: [{
        rotate: '45deg'
      }]
    },
    emphasizerStrip: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      marginTop: SPACING_12,
      marginBottom: emphasizerOnLastRow ? SPACING_0 : SPACING_12,
      borderRadius: BORDER_RADIUS_8,
      backgroundColor: emphasizerColor,
      paddingVertical: SPACING_10,
      paddingHorizontal: SPACING_12,
      textAlign: 'center'
    },
    emphasizerIcon: {
      marginRight: SPACING_4
    }
  });
};